import axios from '@/utils/http';

export default notice => {
  let url = `/advertisement_notice/${notice}`;
  return axios
    .get(url)
    .then(data => Promise.resolve(data.data))
    .catch(err => Promise.reject(err));
};
